import useLocalStorage, {
    LocalStorageKeys,
} from 'app/hooks/useLocalStorage'

/* A hook to manage multiple table states in a single localStorage entry.
 */
function useSkyDataGridLocalStorage<T>(key: string, defaultValue: T) {
    return useLocalStorage({
        key: LocalStorageKeys.SKY_NET_ALL_TABLES_KEY,
        value: key,
        defaultValue,
    })
}

export default useSkyDataGridLocalStorage
